import React from 'react';
import { Text } from '../../components';
import { GET_CAMPAIGNS } from '../../../common/graphql/campaign';
import SearchDropdownSelector from './SearchDropdownSelector';

const CampaignSelector = (props) => {
	const { query } = props;

	return (
		<SearchDropdownSelector
			query={query || GET_CAMPAIGNS}
			renderItem={item => <Text>{ item.name }</Text>}
			renderLabel={item => <Text>{ item.name }</Text>}
			placeholder="Select campaign"
			initialSortBy="name"
			{...props}
		/>
	);
};

export default CampaignSelector;
